import { useState } from "react";
import "./Feedback.css";

export default function FeedbackBox({
  defaultFeedback = "",
  defaultMarks = "",
  defaultStatus = "",
  maxMarks = 100,
  maxFeedbackLength = 250,
  onChange,
  id
}) {
  const [feedback, setFeedback] = useState(defaultFeedback);
  const [marks, setMarks] = useState(defaultMarks);
  const [status, setStatus] = useState(defaultStatus);

  const triggerChange = (updated) => {
    const data = {
      feedback,
      marks,
      status,
      ...updated,
    };
    onChange?.(data);
  };

  const handleMarksChange = (e) => {
    let val = e.target.value;

    if (val === "") {
      setMarks("");
      triggerChange({ marks: "" });
      return;
    }

    val = Number(val);
    if (val > maxMarks) val = maxMarks;
    if (val < 0) val = 0;

    setMarks(val);
    triggerChange({ marks: val });
  };

  const handleFeedbackChange = (e) => {
    let val = e.target.value;

    if (val.length > maxFeedbackLength) {
      val = val.slice(0, maxFeedbackLength);
    }

    setFeedback(val);
    triggerChange({ feedback: val });
  };

  return (
    <div className="feedback-box">
      {/* Header */}
      <div className="feedback-box__header">

        <div className="feedback-box__status">
          <label>
            <input
              type="radio"
              name={`status_${id}`}
              value="unattempted"
              checked={status === "unattempted"}
              onChange={(e) => {
                setStatus(e.target.value);
                triggerChange({ status: e.target.value });
              }}
            />
            <span>Unattempted</span>
          </label>
          <label>
            <input
              type="radio"
              name={`status_${id}`}
              value="correct"
              checked={status === "correct"}
              onChange={(e) => {
                setStatus(e.target.value);
                triggerChange({ status: e.target.value });
              }}
            />
            <span>Correct</span>
          </label>

          <label>
            <input
              type="radio"
              name={`status_${id}`}
              value="incorrect"
              checked={status === "incorrect"}
              onChange={(e) => {
                setStatus(e.target.value);
                triggerChange({ status: e.target.value });
              }}
            />
            <span>Incorrect</span>
          </label>
        </div>
      </div>

      {/* Marks */}
      <div className="feedback-box__field">
        <div className="feedback-box__marks-header">
          <label>Marks</label>
          <span className="feedback-box__max">
            {marks || 0} / {maxMarks}
          </span>
        </div>

        <input
          type="number"
          value={marks}
          placeholder="Enter marks"
          onChange={handleMarksChange}
        />
      </div>

      {/* Feedback */}
      <div className="feedback-box__field">
        <div className="feedback-box__marks-header">
          <label>Feedback</label>
          <span className="feedback-box__max">
            {feedback.length} / {maxFeedbackLength}
          </span>
        </div>

        <textarea
          rows={4}
          value={feedback}
          placeholder="Add feedback..."
          onChange={handleFeedbackChange}
        />
      </div>
    </div>
  );
}